var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '../Typography';
import styles from './Tag.module.css';
var Status = function (_a) {
    var text = _a.text, _b = _a.state, state = _b === void 0 ? 'default' : _b;
    return (_jsx("div", __assign({ className: [styles.container, styles["container-".concat(state)]].join(' ') }, { children: _jsx(Typography, __assign({ variant: "small", className: styles["text-".concat(state)] }, { children: text }), void 0) }), void 0));
};
export default Status;
